<template>
    <!--begin::Form-->
    <el-form
        ref="customForm"
        :id="id"
        :model="model"
        :rules="rules"
        :class="['form w-100', classes]"
        :autocomplete="autocomplete"
        :novalidate="novalidate"
        @submit.prevent="submit"
    >
        <slot></slot>
    </el-form>
    <!--end::Form-->
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import { ElForm } from 'element-plus';
import { CustomForm } from '@/components/logics/forms/CustomForm';

export default defineComponent({
  name: 'custom-form',
  components: { ElForm },
  props: {
    id: {
      // Form's id
      type: String,
      required: true
    },
    submit: {
      // Form's submit function logic
      type: Function,
      default: () => {}
    },
    rules: {
      // Form's rules object
      type: Object,
      default: () => ({})
    },
    model: {
      // Form's model object
      type: Object,
      default: () => ({})
    },
    classes: {
      // Form's classes
      type: String,
      default: ''
    },
    autocomplete: {
      // Form's autocomplete
      type: String,
      default: 'off'
    },
    novalidate: {
      // Form's novalidate
      type: String,
      default: 'novalidate'
    }
  },
  setup(props, { emit }) {
    return CustomForm(props, { emit });
  },
});
</script>
